var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtomic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, " -->\r\n", /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "100px",
    height: "100px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 1707 1707",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0000ee",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 20,
    d: "M338 1378c-27,0 -52,-2 -74,-6 -70,78 -207,30 -207,-80 0,-57 41,-104 94,-116 27,-80 102,-177 209,-274 -36,-33 -69,-66 -97,-99 -110,-125 -148,-233 -107,-304 71,-122 318,-68 451,-26 31,-141 77,-254 134,-317 -25,-75 32,-155 112,-155 80,0 137,80 113,155 56,63 103,176 134,317 132,-42 380,-96 450,26 41,71 3,179 -106,304 -29,33 -61,66 -97,99 107,97 181,194 208,274 54,12 94,59 94,116 0,110 -136,158 -206,80 -101,20 -225,-5 -343,-43 -111,502 -382,502 -493,0 -101,32 -193,49 -269,49zm-151 -158c-111,-8 -108,145 -11,145 95,0 90,-139 11,-145zm616 -1048c46,43 123,12 123,-53 0,-40 -32,-73 -73,-73 -66,0 -96,82 -50,126zm42 65c-32,-2 -60,-17 -80,-39 -49,61 -88,163 -116,290 66,23 135,51 204,85 70,-34 139,-62 204,-85 -27,-127 -67,-229 -115,-290 -23,26 -60,42 -97,39zm692 982c-49,-3 -89,44 -77,92 20,81 144,67 144,-19 0,-38 -30,-69 -67,-73zm-684 -154c-90,0 -164,-73 -164,-164 0,-90 74,-164 164,-164 91,0 165,74 165,164 0,91 -74,164 -165,164zm0 -283c-65,0 -118,54 -118,119 0,66 53,119 118,119 66,0 119,-53 119,-119 0,-65 -53,-119 -119,-119zm-459 89c52,-45 111,-90 175,-134 6,-77 16,-150 29,-218 -102,-33 -347,-94 -402,3 -30,52 7,143 101,251 28,33 61,66 97,98zm919 60c-53,46 -112,91 -176,134 -5,78 -15,152 -28,219 112,36 218,59 309,46 -22,-66 20,-140 89,-154 -29,-72 -97,-158 -194,-245zm-256 384c-65,-23 -134,-52 -204,-86 -69,34 -138,63 -204,86 47,216 127,346 204,346 77,0 158,-130 204,-346zm-255 -112c-62,-32 -126,-69 -185,-106 6,61 13,119 23,173 52,-19 107,-41 162,-67zm-233 -138c-64,-43 -123,-88 -176,-134 -96,87 -165,173 -193,245 71,15 110,89 89,154 91,13 199,-11 308,-46 -13,-67 -22,-141 -28,-219zm336 -466c62,32 126,69 184,107 -5,-61 -13,-119 -23,-173 -52,19 -106,41 -161,66zm232 138c64,44 123,89 176,134 36,-32 68,-65 97,-98 146,-167 163,-303 -41,-303 -72,0 -162,17 -260,49 13,68 23,141 28,218zm-709 164c42,36 88,72 138,107 -3,-70 -3,-144 0,-213 -50,35 -96,70 -138,106zm185 139c75,50 159,98 240,138 81,-40 165,-88 241,-138 5,-89 5,-188 0,-277 -76,-50 -160,-99 -241,-139 -81,40 -165,89 -240,139 -5,89 -5,188 0,277zm292 163c55,26 109,48 162,67 9,-54 17,-111 22,-173 -58,37 -122,74 -184,106zm374 -302c-42,-36 -88,-71 -138,-106 3,69 3,143 0,213 49,-35 96,-71 138,-107zm-477 -302c-55,-25 -109,-47 -162,-66 -9,54 -17,112 -23,173 59,-38 123,-75 185,-107z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtomic);
export default __webpack_public_path__ + "static/media/atomic.87a5192d3fedf0965530551402e70e9a.svg";
export { ForwardRef as ReactComponent };